<iframe #embeddedClientFrame sandbox="allow-scripts allow-same-origin" width="100%" height="100%"></iframe>